import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges, OnDestroy, Output, EventEmitter, AfterViewInit
} from '@angular/core';
import * as c3 from 'c3';
import { GraphUtilsService } from '../../services/graph-utils.service';
import { DataService } from '../../services/data.service';
let vm;
@Component({
  selector: 'app-c3-drill-down-bar',
  templateUrl: './c3-drill-down-bar.component.html',
  styleUrls: ['./c3-drill-down-bar.component.scss'],
  standalone: false
})
export class C3DrillDownBarComponent implements OnChanges, AfterViewInit, OnDestroy {
  @Input() drillData: any;
  @Input() colour: any;
  @Input() from: string = '';
  @Input() matGrpValue = '';
  @Output() selectedItem: EventEmitter<object> = new EventEmitter();

  egaChart: any = null;
  subscription: any;
  selectedPoints: any[] = [];
  colorObj = {};
  constructor(
    private elRef: ElementRef,
    private graphUtil: GraphUtilsService,
    private dataSer: DataService
  ) {
    this.subscription = dataSer.events.subscribe(this.replotGraphEventSubscription);
    vm = this;
  }

  replotGraphEventSubscription = (res: any) => {
    if (res.name === 'replotGraph') {
      let timeoutval = 0;
      if (res.args && res.args[0] === 'menuToggle') {
        timeoutval = 101;
      }
      setTimeout(() => {
        this.checkAndReplotGraph();
      }, timeoutval);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    //  changed to fix memory leak
    if (this.egaChart) {
      this.egaChart.destroy();
    }
    this.checkAndReplotGraph();
  }

  ngAfterViewInit(): void {
    this.checkAndReplotGraph();
  }

  checkAndReplotGraph() {
    this.generateChart(this.drillData);
    this.selectedPoints = [];
  }

  private getAxisLabel(label: string, shouldTruncate: boolean): string {
    const value = String(label || '');
    if (!shouldTruncate) {
      return value;
    }
    return value.length > 15 ? `${value.slice(0, 15)}...` : value;
  }

  private getChartHeight(): number {
    return this.drillData.length < 10 ? 300 : 350;
  }

  generateChart = (data) => {
    const shouldRotateLabels = this.drillData.length > 10;
    const categories = this.drillData.map(elem => this.getAxisLabel(elem.name, shouldRotateLabels));
    if (this.matGrpValue === 'cost') {
      this.colorObj = { cost: this.colour };
    } else if (this.matGrpValue === 'ton') {
      this.colorObj = { ton: this.colour };
    } else {
      this.colorObj = { percentage: this.colour };
    }
    const graph: any = {
      bindto: this.elRef.nativeElement.children[0],
      size: {
        height: this.getChartHeight()
      },
      padding: {
        bottom: 0,
        left: 45,
        right: 20,
        top: 0
      },
      data: {
        columns: [
          ['value', ...this.drillData.map(elem => elem.value)]
        ],
        type: 'bar',
        colors: {
          value: this.colour
        },
        onclick: (d) => {
          this.onBarClick(d);
        }
      },
      bar: {
        width: 30
      },
      axis: {
        rotated: false,
        x: {
          type: 'category',
          categories,
          tick: {
            rotate: shouldRotateLabels ? 90 : 0,
            multiline: false,
            culling: false
          }
        },
        y: {
          label: {
            text: 'Give Away Cost',
            position: 'outer-middle'
          }
        }
      },
      legend: {
        show: false
      }
    };
    if (this.from === 'drill-down') {
      graph.tooltip = this.createTooltip();
    }
    this.egaChart = c3.generate(graph);
  }

  onBarClick(item: any) {
    if (item) {
      this.selectedItem.emit({ type: this.drillData[0].type, index: item.index });
    }
  }

  createTooltip(): any {
    const tooltip = {
      format: {
        value: (value, ratio, id) => {
          return value;
        }
      },
      contents: function (d, title, value, color) {
        const index: number = d[0].index;
        const bar = vm.drillData[index];
        const skuRow = bar.skuName ? `<tr class="c3-tooltip-name--value">
                            <td class="name">SKU Name</td>
                            <td class="value">${bar.skuName}</td>
                        </tr>` : '';
        const str = `<table class="c3-tooltip">
                      <tbody>
                        <tr>
                            <th colspan="2">${bar.name}</th>
                        </tr>
                        ${skuRow}
                        <tr class="c3-tooltip-name--value">
                            <td class="name"><span style="background-color:#5cc4c9"></span>Total Cost</td>
                            <td class="value">${bar.value}</td>
                        </tr>
                      </tbody>
                  </table>`;
        return str;
      }
    };
    return tooltip;
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
